import React, { Component } from 'react'
import { getTareasClienteFiltrado, editTarea, postAprobarTarea, deleteTarea, getClienteTareas, clearErrors } from '../../../redux/actions/dataactions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { FaArrowLeft, FaCheck, FaPlus, FaCheckCircle, FaCircle, FaExclamationTriangle, FaTrash, FaFirstAid, FaSearch } from "react-icons/fa";
import MyButton from '../../../utils/MyButton';
import { Link } from 'react-router-dom';
import Button from '../../Elements/Button';
import moment from 'moment';
import TareasIndicadoresDialog from './TareasIndicadoresDialog';
import CrearTarea from '../Tareas/CrearTarea';
// Importaciones MUI v5
import {
  TextField, Dialog, DialogActions, DialogContent, DialogTitle,
  FormControl, MenuItem, Select, InputLabel, FormHelperText, CircularProgress,
  Tooltip, IconButton, Box, Grid, Typography, Button as MuiButton
} from '@mui/material';

import { DataGrid, esES, GridToolbarQuickFilter } from '@mui/x-data-grid';

import AssignmentIcon from '@mui/icons-material/Assignment';
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import './TablaTareas.css';





export class TablaTareas extends Component {

  constructor() {
    super();
    this.state = {
      tareaid: '',
      nombretarea: '',
      detalles: '',
      fechaplazo: '',
      horaplazo: '',
      prioridad: '',
      handleasignado: '',
      tipotarea: '',
      errors: {},
      open: false,
      openaprobado: false,
      opendelete: false,
      openedit: false,
      selected: '',
      fechaInicio: '',
      fechaFin: '',
      searchQuery: '',
      aprobado: {},




    };

  };

  componentDidMount() {
    this.props.getTareasClienteFiltrado(this.props.clienteId, "01/01/1950", "01/01/2035");
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};

    if (props.UI.errors) {
      newState.errors = props.UI.errors;
    }

    if (props.UI.aprobado) {
      newState.aprobado = props.UI.aprobado;
    }

    return Object.keys(newState).length > 0 ? newState : null;
  }

  handleOpen = (rowdata) => {

    this.setState({
      handlecreador: '',
      nombretarea: rowdata.nombretarea,
      detalles: rowdata.detalles,
      fechaplazo: rowdata.fechaplazo,
      horaplazo: rowdata.horaplazo,
      prioridad: rowdata.prioridad,
      handleasignado: rowdata.handleasignado,
      tipotarea: rowdata.tipotarea, open: true, aprobado: {}
    });
  };
  handleClose = () => {

    this.setState({
      handlecreador: '',
      nombretarea: '',
      detalles: '',
      fechaplazo: '',
      horaplazo: '',
      prioridad: '',
      handleasignado: '',
      tipotarea: '', open: false, aprobado: {}
    });
  };


  handleOpenAprobado = (rawdatatareaid) => {

    this.setState({ openaprobado: true, tareaid: rawdatatareaid, errors: {}, aprobado: {} });

  };
  handleCloseAprobado = () => {
    // this.props.clearErrors();
    if (this.state.aprobado.mensaje || this.state.errors.error) {

      this.props.getTareasClienteFiltrado(this.props.clienteId, "01/01/1950", "01/01/2035");
      this.setState({ openaprobado: false, errors: {}, tareaid: {}, aprobado: {} });
    }

    this.setState({ openaprobado: false, errors: {}, tareaid: {}, aprobado: {} });
  };

  // hay que hacer otro aprobar mto 
  handleSubmit = () => {
    this.props.postAprobarTarea(this.state.tareaid);
  }

  handleOpenDelete = (rawdatatareaid) => {

    this.setState({ opendelete: true, tareaid: rawdatatareaid, errors: {}, aprobado: {} });

  };

  handleCloseDelete = () => {

    if (this.state.aprobado.mensaje) {
      //this.handleEditProgMto();
      //get prog mtos 
      this.props.getTareasClienteFiltrado(this.props.clienteId, "01/01/1950", "01/01/2035");
      this.setState({ opendelete: false, errors: {}, aprobado: {} });
    } else {
      this.setState({ opendelete: false, errors: {}, aprobado: {} });
    }
    // this.props.clearErrors();
  };
  handleDelete = () => {

    this.props.deleteTarea(this.state.tareaid);
  }


  handleOpenEdit = (rowdata) => {
    this.props.getClienteTareas(this.props.clienteId)
    this.setState({
      tareaid: rowdata.tareaid,
      nombretarea: rowdata.nombretarea,
      detalles: rowdata.detalles,
      fechaplazo: rowdata.fechaplazo,
      horaplazo: rowdata.horaplazo,
      prioridad: rowdata.prioridad,
      handleasignado: rowdata.handleasignado,
      tipotarea: rowdata.tipotarea, openedit: true, aprobado: {}
    });
  };


  handleCloseEdit = () => {


    if (this.state.aprobado.mensaje) {
      //getEquipos this.handleEditProgMto();
      this.props.getTareasClienteFiltrado(this.props.clienteId, "01/01/1950", "01/01/2035");

      this.setState({
        tareaid: '',
        nombretarea: '',
        detalles: '',
        fechaplazo: '',
        horaplazo: '',
        prioridad: '',
        handleasignado: '',
        tipotarea: '',
        openedit: false, errors: {}, aprobado: {}
      });
    } else {
      this.setState({

        openedit: false, errors: {}, aprobado: {}
      });
    }



  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSubmitEdit = (event) => {
    event.preventDefault();

    const newUserData = {

      nombretarea: this.state.nombretarea,
      detalles: this.state.detalles,
      fechaplazo: this.state.fechaplazo,
      horaplazo: this.state.horaplazo,
      prioridad: this.state.prioridad,
      handleasignado: this.state.handleasignado,
      tipotarea: this.state.tipotarea


    };

    console.log(newUserData)

    this.props.editTarea(newUserData, this.state.tareaid);



  }

  handleFiltrar = (filtro) => () => {
    if (filtro == 'todo') {
      this.props.getTareasClienteFiltrado(this.props.clienteId, "01/01/1950", "01/01/2035");
    }

    if (filtro == 'vencenhoy') {
      const hoy = new Date();
      const dia = String(hoy.getDate()).padStart(2, '0');
      const mes = String(hoy.getMonth() + 1).padStart(2, '0');
      const anio = hoy.getFullYear();
      const fechaHoy = `${dia}/${mes}/${anio}`;
      console.log('Fecha hoy' + fechaHoy);
      this.props.getTareasClienteFiltrado(this.props.clienteId, fechaHoy, fechaHoy);
    }

    if (filtro == 'proximamente') {
      const hoy = new Date();
      const dia = String(hoy.getDate()).padStart(2, '0');
      const mes = String(hoy.getMonth() + 1).padStart(2, '0');
      const anio = hoy.getFullYear();
      const fechaHoy = `${dia}/${mes}/${anio}`;
      console.log('Fecha hoy' + fechaHoy);
      this.props.getTareasClienteFiltrado(this.props.clienteId, fechaHoy, "01/01/2035");
    }

    if (filtro == 'atrasadas') {
      const hoy = new Date();
      const dia = String(hoy.getDate()).padStart(2, '0');
      const mes = String(hoy.getMonth() + 1).padStart(2, '0');
      const anio = hoy.getFullYear();
      const fechaHoy = `${dia}/${mes}/${anio}`;
      console.log('Fecha hoy' + fechaHoy);
      this.props.getTareasClienteFiltrado(this.props.clienteId, "01/01/1950", fechaHoy);
    }
    console.log('Filtrado ejecutado con filtro:', filtro);
    this.setState({ selected: filtro })
  };

  handleFiltrarFuncion = () => {
    console.log(this.state.fechaFin, this.state.fechaFin)
    this.props.getTareasClienteFiltrado(this.props.clienteId, moment(this.state.fechaInicio).format('DD/MM/YYYY'), moment(this.state.fechaFin).format('DD/MM/YYYY'));

  }

  handleSearchChange = (event) => {
    this.setState({ searchQuery: event.target.value });
  };

  handleResetFiltros = () => {
    this.setState({
      fechaInicio: '',
      fechaFin: '',
      searchQuery: '',
      selected: 'todo'
    });
    this.props.getTareasClienteFiltrado(this.props.clienteId, "01/01/1950", "01/01/2035");
  };

  render() {
    const { UI: { loading } } = this.props;
    const { tareas, loadingdata } = this.props.data;
    const { errors } = this.state;
    const { ingenieros } = this.props.data.cliente;

    // Preparar columnas de DataGrid
    const columns = [
      {
        field: 'acciones',
        headerName: 'Acciones',
        width: 150,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        renderCell: (params) => {
          const isRealizado = params.row.realizado === true;
          return (
            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
              <Tooltip title="Ver Tarea">
                <IconButton size="small" onClick={() => this.handleOpen(params.row, "ver")}>
                  <AssignmentIcon fontSize="small" />
                </IconButton>
              </Tooltip>

              <Tooltip title="Borrar Tarea">
                <IconButton size="small" onClick={() => this.handleOpenDelete(params.row.tareaid)}>
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>

              <Tooltip title="Editar Tarea">
                <span style={{ cursor: isRealizado ? 'not-allowed' : 'pointer' }}>
                  <IconButton
                    size="small"
                    disabled={isRealizado}
                    onClick={() => this.handleOpenEdit(params.row)}
                  >
                    <EditIcon fontSize="small" style={{ color: isRealizado ? 'gray' : 'black' }} />
                  </IconButton>
                </span>
              </Tooltip>

              <Tooltip title="Marcar Como Realizada">
                <span style={{ cursor: isRealizado ? 'not-allowed' : 'pointer' }}>
                  <IconButton
                    size="small"
                    disabled={isRealizado}
                    onClick={() => this.handleOpenAprobado(params.row.tareaid)}
                  >
                    <CheckIcon fontSize="small" style={{ color: isRealizado ? 'green' : 'red' }} />
                  </IconButton>
                </span>
              </Tooltip>
            </Box>
          );
        }
      },
      {
        field: 'realizado',
        headerName: 'Realizada',
        width: 100,
        renderCell: (params) => (
          params.row.realizado ? 'Sí' : 'No'
        )
      },
      { field: 'nombretarea', headerName: 'Nombre Tarea', width: 250 },
      { field: 'fechaplazo', headerName: 'Fecha Plazo', width: 150 },
      { field: 'mesnombre', headerName: 'Mes', width: 130 },
      { field: 'prioridad', headerName: 'Prioridad', width: 130 },
      { field: 'handleasignado', headerName: 'Asignado', width: 130 }
    ];

    const rows = Array.isArray(tareas)
      ? tareas.map((row, index) => ({ id: row.tareaid || index, ...row }))
      : [];

    let mapeotareas = !loadingdata ? (
      <Box
        sx={{
          height: 500,
          width: '100%',
          backgroundColor: '#fff',
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: 'primary.main',
            color: 'white',
            fontSize: '14px',
            fontWeight: 'bolder'
          }
        }}
      >
        <h2 style={{ fontSize: '16px', color: '#03178c', fontWeight: '600', padding: '10px' }}>Mis Tareas</h2>
        <DataGrid
          rows={rows}
          columns={columns}
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          initialState={{
            sorting: {
              sortModel: [{ field: 'fechaplazo', sort: 'desc' }],
            },
          }}
          components={{
            Toolbar: () => (
              <Box p={1}>
                <GridToolbarQuickFilter placeholder="Buscar..." />
              </Box>
            )
          }}
        />
      </Box>
    ) : (<div className="div_cargando">
      <CircularProgress size={50} color="primary" className="login-progress" />
    </div>);
    return (
      <div>
        <div className='div-container-links-inventario'>
          <CrearTarea clienteId={this.props.clienteId}></CrearTarea>
          <TareasIndicadoresDialog clienteId={this.props.clienteId}></TareasIndicadoresDialog>
        </div>

        <Grid container spacing={2} sx={{ mb: 3 }} width={"95%"}>
          {[
            { id: 'todo', label: 'Todo' },
            { id: 'vencenhoy', label: 'Vencen Hoy' },
            { id: 'atrasadas', label: 'Atrasadas' },
            { id: 'proximamente', label: 'Próximamente' },
          ].map((filtro) => (
            <Grid item xs={6} sm={3} key={filtro.id}>
              <MuiButton
                fullWidth
                variant={this.state.selected === filtro.id ? "contained" : "outlined"}
                color="primary"
                onClick={this.handleFiltrar(filtro.id)}
                sx={{
                  height: '100%',
                  py: 1,
                  fontWeight: 'normal',
                  textTransform: 'none',
                  fontSize: '1rem',
                  borderRadius: 1,
                  boxShadow: this.state.selected === filtro.id ? 3 : 1
                }}
              >
                {filtro.label}
              </MuiButton>
            </Grid>
          ))}
        </Grid>

        {(this.state.selected === 'todo' || this.state.selected === '') && (
          <Box sx={{ mt: 2, mb: 2 }} width={"95%"}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={4} md={3}>
                <TextField
                  fullWidth
                  size="small"
                  required
                  type="date"
                  name="fechaInicio"
                  id="fechaInicio"
                  label="Desde"
                  value={this.state.fechaInicio}
                  onChange={this.handleChange}
                  helperText={errors.fechaInicio}
                  error={Boolean(errors.fechaInicio)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={4} md={3}>
                <TextField
                  fullWidth
                  size="small"
                  required
                  type="date"
                  name="fechaFin"
                  id="fechaFin"
                  label="Hasta"
                  value={this.state.fechaFin}
                  onChange={this.handleChange}
                  helperText={errors.fechaFin}
                  error={Boolean(errors.fechaFin)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={4} md={3}>
                <MuiButton
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={this.handleFiltrarFuncion}
                  size="medium"
                  sx={{ height: '40px' }}
                >
                  Filtrar
                </MuiButton>
              </Grid>

              <Grid item xs={12} sm={4} md={3}>
                <MuiButton
                  fullWidth
                  variant="outlined"
                  color="primary"
                  onClick={this.handleResetFiltros}
                  size="medium"
                  sx={{ height: '40px' }}
                >
                  Restablecer
                </MuiButton>
              </Grid>
            </Grid>
          </Box>
        )}
        <div className="listamtoprog-table">
          {mapeotareas}
        </div>

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
        >

          {this.state.aprobado.mensaje ? (

            <div className='div-aprobado'>
              <div className='div-icono-aprobado'>
                <FaCheck color="#ffffff" className='icono-aprobado' />
              </div>
              <h2 className='text-aprobado'>¡Creación de Tarea Exitosa!</h2>
            </div>

          ) : (<div>

            <DialogTitle className="text-title-accorion">{this.state.nombretarea}</DialogTitle>

            <DialogContent dividers>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant="body1" sx={{ color: '#333' }}>
                    {this.state.detalles}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="caption" color="textSecondary">
                    Fecha de Vencimiento
                  </Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {this.state.fechaplazo} - {this.state.horaplazo}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="caption" color="textSecondary">
                    Tipo de Tarea
                  </Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {this.state.tipotarea}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="caption" color="textSecondary">
                    Prioridad
                  </Typography>
                  <Box display="flex" alignItems="center" gap={1}>
                    {this.state.prioridad === "Alta" && <FaCircle color="#f2545b" size={12} />}
                    {this.state.prioridad === "Media" && <FaCircle color="#f5c26b" size={12} />}
                    {this.state.prioridad === "Baja" && <FaCircle color="#00bda5" size={12} />}
                    <Typography variant="body1" fontWeight="bold">
                      {this.state.prioridad || "N/A"}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="caption" color="textSecondary">
                    Asignado A
                  </Typography>
                  <Typography variant="body1" fontWeight="bold" sx={{ color: '#03178C' }}>
                    @{this.state.handleasignado}
                  </Typography>
                </Grid>
              </Grid>

            </DialogContent>
          </div>)}


          <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleClose}>
              <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
            </MyButton>





          </DialogActions>
        </Dialog>


        <Dialog
          open={this.state.openaprobado}
          onClose={this.handleCloseAprobado}
          fullWidth
          maxWidth="sm"
        >

          {this.state.aprobado.mensaje ? (

            <div className='div-aprobado'>
              <div className='div-icono-aprobado'>
                <FaCheck color="#ffffff" className='icono-aprobado' />
              </div>
              <h2 className='text-aprobado'>Tarea Realizada Exitosamente</h2>
            </div>

          ) : (errors.error ? (<div className='div-aprobado'>
            <div className='div-icono-advertencia'>
              <FaExclamationTriangle color="#ffffff" className='icono-aprobado' />
            </div>
            <h2 className='text-aprobado'>{errors.error}</h2>
          </div>) : (<div>
            <DialogTitle>¿Estás seguro de marcar esta tarea como realizada?</DialogTitle>
          </div>))}


          <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleCloseAprobado}>
              <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
            </MyButton>
            {loading ? (
              <CircularProgress size={30} color="primary" className="login-progress" />
            ) : (
              this.state.aprobado.mensaje ? (
                <MyButton tip="Continuar" onClick={this.handleCloseAprobado}>
                  <FaCheckCircle color="#20b90c" className="icon-formulario" />
                </MyButton>
              ) : (errors.error ? (
                <Link to={`/dashboard/perfilcliente/${this.props.clienteId}/tareas`} style={{ color: '#ffd631' }}>
                  <FaCheckCircle color="#ffd631" className="icon-formulario" />
                </Link>
              ) : (
                <MyButton tip="Aprobar Mantenimiento" onClick={this.handleSubmit}>
                  <FaCheckCircle color="#03178C" className="icon-formulario" />
                </MyButton>)
              )
            )}

          </DialogActions>
        </Dialog>


        <Dialog
          open={this.state.opendelete}
          onClose={this.handleCloseDelete}
          fullWidth
          maxWidth="sm"
        >

          {this.state.aprobado.mensaje ? (

            <div className='div-aprobado'>
              <div className='div-icono-delete'>
                <FaTrash color="#ffffff" className='icono-aprobado' />
              </div>
              <h2 className='text-aprobado'>Tarea Borrada Exitosamente</h2>
            </div>

          ) : (<div>
            <DialogTitle>¿Estás seguro de borrar esta Tarea?</DialogTitle>
          </div>)}


          <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleCloseDelete}>
              <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
            </MyButton>
            {loading ? (
              <CircularProgress size={30} color="primary" className="login-progress" />
            ) : (
              this.state.aprobado.mensaje ? (
                <MyButton tip="Continuar" onClick={this.handleCloseDelete}>
                  <FaCheckCircle color="#f9044e" className="icon-formulario" />
                </MyButton>
              ) : (
                <MyButton tip="Borrar Tarea" onClick={this.handleDelete}>
                  <FaTrash color="#03178C" className="icon-formulario" />
                </MyButton>
              )
            )}

          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.openedit}
          onClose={this.handleCloseEdit}
          fullWidth
          maxWidth="sm"
        >

          {this.state.aprobado.mensaje ? (

            <div className='div-aprobado'>
              <div className='div-icono-aprobado'>
                <FaCheck color="#ffffff" className='icono-aprobado' />
              </div>
              <h2 className='text-aprobado'>¡Creación de Tarea Exitosa!</h2>
            </div>

          ) : (<div>

            <DialogTitle className="text-title-accorion">Editar Tarea</DialogTitle>

            <DialogContent>

              <form>
                <Grid container spacing={2}>
                  {/* Nombre y Detalles */}
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" sx={{ color: '#03178C', fontWeight: 'bold', mb: 1 }}>
                      Información General
                    </Typography>
                    <TextField
                      required
                      type="text"
                      name="nombretarea"
                      id="nombretarea"
                      label="Nombre de la Tarea"
                      value={this.state.nombretarea}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      helperText={errors.nombretarea}
                      error={Boolean(errors.nombretarea)}
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      required
                      type="text"
                      name="detalles"
                      id="detalles"
                      label="Detalles de la Tarea"
                      value={this.state.detalles}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      multiline
                      rows={3}
                      helperText={errors.detalles}
                      error={Boolean(errors.detalles)}
                    />
                  </Grid>

                  {/* Fechas y Prioridad */}
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" sx={{ color: '#03178C', fontWeight: 'bold', mb: 1, mt: 1 }}>
                      Planificación y Estado
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      type="date"
                      name="fechaplazo"
                      id="fechaplazo"
                      label="Fecha de Vencimiento"
                      value={this.state.fechaplazo}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      helperText={errors.fechaplazo}
                      error={Boolean(errors.fechaplazo)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      type="time"
                      name="horaplazo"
                      id="horaplazo"
                      label="Hora de Vencimiento"
                      value={this.state.horaplazo}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      helperText={errors.horaplazo}
                      error={Boolean(errors.horaplazo)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth size="small" error={Boolean(errors.tipotarea)}>
                      <InputLabel>Tipo de Tarea</InputLabel>
                      <Select
                        required
                        name="tipotarea"
                        id="tipotarea"
                        value={this.state.tipotarea}
                        onChange={this.handleChange}
                        fullWidth
                        label="Tipo de Tarea"
                      >
                        <MenuItem value=""><em>Ninguno</em></MenuItem>
                        <MenuItem value="Biomedica">Biomedica</MenuItem>
                        <MenuItem value="Infraestructura">Infraestructura</MenuItem>
                        <MenuItem value="Computo">Computo</MenuItem>
                        <MenuItem value="Mobiliario">Mobiliario</MenuItem>
                        <MenuItem value="Industrial">Industrial</MenuItem>
                      </Select>
                      {errors.tipotarea && <FormHelperText>{errors.tipotarea}</FormHelperText>}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth size="small" error={Boolean(errors.prioridad)}>
                      <InputLabel>Prioridad</InputLabel>
                      <Select
                        required
                        name="prioridad"
                        id="prioridad"
                        value={this.state.prioridad}
                        onChange={this.handleChange}
                        fullWidth
                        label="Prioridad"
                      >
                        <MenuItem value=""><em>Ninguno</em></MenuItem>
                        <MenuItem value="Alta">
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <FaCircle color="#f2545b" size={10} /> Alta
                          </Box>
                        </MenuItem>
                        <MenuItem value="Media">
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <FaCircle color="#f5c26b" size={10} /> Media
                          </Box>
                        </MenuItem>
                        <MenuItem value="Baja">
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <FaCircle color="#00bda5" size={10} /> Baja
                          </Box>
                        </MenuItem>
                      </Select>
                      {errors.prioridad && <FormHelperText>{errors.prioridad}</FormHelperText>}
                    </FormControl>
                  </Grid>

                  {/* Asignación */}
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" sx={{ color: '#03178C', fontWeight: 'bold', mb: 1, mt: 1 }}>
                      Personal Asignado
                    </Typography>
                    {ingenieros && ingenieros.length > 0 ? (
                      <FormControl fullWidth size="small" error={Boolean(errors.handleasignado)}>
                        <InputLabel>Personal designado</InputLabel>
                        <Select
                          required
                          name="handleasignado"
                          id="handleasignado"
                          value={this.state.handleasignado}
                          onChange={this.handleChange}
                          fullWidth
                          label="Personal designado"
                        >
                          {ingenieros.map((ingeniero, index) => (
                            <MenuItem key={index} value={ingeniero}>
                              @{ingeniero}
                            </MenuItem>
                          ))}
                        </Select>
                        {errors.handleasignado && <FormHelperText>{errors.handleasignado}</FormHelperText>}
                      </FormControl>
                    ) : (
                      <Typography variant="body2" color="error">
                        Este perfil de cliente/prestador no tiene ingenieros asociados.
                      </Typography>
                    )}
                  </Grid>

                </Grid>
              </form>

            </DialogContent>
          </div>)}


          <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleCloseEdit}>
              <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
            </MyButton>

            {loading ? (
              <CircularProgress size={30} color="primary" className="login-progress" />
            ) : (
              this.state.aprobado.mensaje ? (
                <MyButton tip="Continuar" onClick={this.handleCloseEdit}>
                  <FaCheckCircle color="#20B90C" className="icon-formulario" />
                </MyButton>
              ) : (
                <MyButton tip="Crear Tarea" onClick={this.handleSubmitEdit}>
                  <FaPlus color="#03178C" className="icon-formulario" />
                </MyButton>
              )
            )}




          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

TablaTareas.propTypes = {
  getTareasClienteFiltrado: PropTypes.func.isRequired,
  postAprobarTarea: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  deleteTarea: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  editTarea: PropTypes.func.isRequired,
  getClienteTareas: PropTypes.func.isRequired
};

const mapActionsToProps = { getTareasClienteFiltrado, editTarea, deleteTarea, postAprobarTarea, getClienteTareas, clearErrors };

const mapStateToProps = (state) => ({
  data: state.data,
  UI: state.UI,

  user: state.user,
})



export default connect(mapStateToProps, mapActionsToProps)(TablaTareas);